import { ApiConfiguration } from '@celum/authentication';

import {
  createB2CTokenApiConfigForPortals,
  createCdnTokenApiConfigForPortals,
  createCloudTokenApiConfigForPortals,
  createIdentityAndCloudTokenApiConfigForPortals
} from '../model/api-configuration';

export function getPortalApiConfigurations(tenantId: string): ApiConfiguration[] {
  return [
    createB2CTokenApiConfigForPortals(tenantId),
    createIdentityAndCloudTokenApiConfigForPortals(tenantId),
    createCloudTokenApiConfigForPortals(tenantId),
    createCdnTokenApiConfigForPortals(tenantId)
  ];
}
